module.exports = __webpack_public_path__ + "static/media/OTK_header4.4d16cf34.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/OTK_header4.png
// module id = 296
// module chunks = 0